// @flow

import React from 'react';
import { connect } from 'react-redux';
import {
  toggleUiBooleanSetting,
  getUiSetting,
} from '../../../../store/uiStore';
import { withErrorEmptyComponent } from '../../../emptyComponent';
import { choiceGroupMapper } from './helpers';
import { Title, Description, ConfigChoiceWrapper } from './atoms';
import { shouldShowErrors } from '../../../../store/uiStore/validation/index';
import { choiceGroupHasError } from '../../../../store/configuration/actives';
import { getModelData } from '../../../../../src/store/pdb';

type OwnProps = {|
  title: string,
  description: string,
  type: string,
  errorText?: ?string,
|};

type StateProps = {|
  activeModel: Object,
  isOpen: boolean,
  hasError: ?boolean,
  showError: ?boolean,
|};

type DispatchProps = {|
  toggleDescription: Function,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
  ...DispatchProps,
|};

const ConfigChoice = ({
  title,
  description,
  type,
  toggleDescription,
  isOpen,
  errorText,
  hasError,
  showError,
  activeModel,
}: Props) => {
  const EmptyComponent = withErrorEmptyComponent(`Couldn't map ${type} to a component in ConfigChoice`);
  const ChoiceGroup = choiceGroupMapper[type] || EmptyComponent;
  return (
    <ConfigChoiceWrapper>
      <Title
        onClick={toggleDescription}
        isOpen={isOpen}
      >
        {title}
      </Title>
      <Description
        isOpen={isOpen}
        dangerouslySetInnerHTML={{ __html: description.replace('[km_price]', activeModel.km_price || '0') }}
      />
      <ChoiceGroup
        blocksPerRow={4}
        errorText={errorText}
        showError={showError && hasError}
      />
    </ConfigChoiceWrapper>
  );
};

ConfigChoice.defaultProps = {
  errorText: null,
};

const mapStateToProps = (state, ownProps: OwnProps): StateProps => ({
  activeModel: getModelData(state),
  showError: shouldShowErrors(state),
  hasError: choiceGroupHasError(state, ownProps.type),
  isOpen: getUiSetting(state, `ConfigChoice-${ownProps.type || ''}`),
});

const mapDispatchToProps = (dispatch: Function, ownProps: OwnProps): DispatchProps => ({
  toggleDescription: () => dispatch(toggleUiBooleanSetting(`ConfigChoice-${ownProps.type || ''}`)),
});

export default connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)(ConfigChoice);
